
import { ref } from "vue";
import TabBox from "../Store/TabBox.vue";
import EquipPack from "./EquipPack.vue";
import Attrs from "./Attrs.vue";
export default {
  name: "PackDialog",
  components: {
    TabBox,
    EquipPack,
    Attrs
  },
  setup() {
    const Dialog = ref();
    const close = () => {
      Dialog.value.close();
    };
    const open = () => {
      Dialog.value.open();
    };
    return {
      Dialog,
      close,
      open
    };
  }
};
